import React, { Fragment, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Row, Col } from 'react-bootstrap';

import TaskCard from './TaskCard';
import TaskComments from './TaskComments';

import Shimmer from '../../../../components/Custom/Loading/Shimmer';

import { MarkViewView } from '../../../../../services/ccms/taskManagement/tasks/tasks_endpoints';
import { addTaskToQueue } from '../../../../../services/ccms/taskQueue';

const ViewTask = () => {
    const location = useLocation();
    const [taskModelView, setTaskModelView] = useState(location.state || {});
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        const markView = async () => {
            try {
                const response = await MarkViewView(taskModelView);
                if(response.status === 'Success')
                {
                    setTaskModelView(response.results);
                }
                
            } catch (err) {
                setError('Failed to load task data');
            } finally {
                setLoading(false);
            }
        };

        // Wrap the markView function in a task and add it to the queue
        // const task = async () => {
        //     setLoading(true);
        //     await markView();
        // };
        markView();
        //addTaskToQueue(task, 'high'); // Add to queue with high priority
    }, [taskModelView]);

    return (
        <Fragment>
            {loading ? (
                <Shimmer type='page' />
            ) : error ? (
                <div>{error}</div>
            ) : (
                <>
                    <TaskCard task={taskModelView} />
                    <Row>
                        <Col>
                            <TaskComments taskID={taskModelView.taskID} />
                        </Col>
                    </Row>
                </>
            )}
        </Fragment>
    );
};

export default ViewTask;
